import InventoryTopOrderItemsChart from 'components/charts/e-charts/InventoryTopOrderItemsChart';
import { Card } from 'react-bootstrap';

interface JobItems {
  name: string;
  percentage: string;
  total: number;
}

interface InventoryTopOrderItemsCardProps {
  jobItems: JobItems[];
}

const InventoryTopOrderItemsCard = ({
  jobItems
}: InventoryTopOrderItemsCardProps) => {
  return (
    <Card className="h-100">
      <Card.Body>
        <div className="d-flex justify-content-between">
          <div>
            <h5 className="mb-2">Total jobs</h5>
            <h6 className="text-700"></h6>
          </div>
        </div>
        <div className="pb-4 pt-3">
          <InventoryTopOrderItemsChart topOrderItems={jobItems} />
        </div>
        <div>
          <div className="d-flex align-items-center mb-2">
            <div className="bullet-item bg-primary me-2"></div>
            <h6 className="text-900 fw-semi-bold flex-1 mb-0">
              {jobItems && jobItems.length >= 1 && jobItems[0].name}
            </h6>
            <h6 className="text-900 fw-semi-bold mb-0">
              {jobItems &&
                jobItems.length >= 1 &&
                `${parseInt(jobItems[0].percentage)}%`}
            </h6>
          </div>
          <div className="d-flex align-items-center mb-2">
            <div className="bullet-item bg-primary-200 me-2"></div>
            <h6 className="text-900 fw-semi-bold flex-1 mb-0">
              {jobItems && jobItems.length >= 2 && jobItems[1].name}
            </h6>
            <h6 className="text-900 fw-semi-bold mb-0">
              {jobItems &&
                jobItems.length >= 2 &&
                `${parseInt(jobItems[1].percentage)}%`}
            </h6>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default InventoryTopOrderItemsCard;
